import styled, { css } from 'styled-components';
import { TagStatus } from './enums';
import { TagProps } from './types';

const STATUS_TOKENS: Record<
  TagStatus,
  { bg: string; border: string; text: string; dot: string }
> = {
  [TagStatus.Success]: {
    bg: 'var(--success-soft)',
    border: 'rgba(118,177,89,0.3)',
    text: 'var(--success-ink)',
    dot: 'var(--brand-green)',
  },
  [TagStatus.Error]: {
    bg: 'var(--danger-soft)',
    border: 'rgba(212,121,116,0.3)',
    text: 'var(--danger-ink)',
    dot: 'var(--danger)',
  },
  [TagStatus.Warning]: {
    bg: 'var(--warning-soft)',
    border: 'rgba(218,146,19,0.3)',
    text: 'var(--warning-ink)',
    dot: 'var(--warning)',
  },
  [TagStatus.Info]: {
    bg: 'var(--info-soft)',
    border: 'rgba(74,120,214,0.3)',
    text: 'var(--info-ink)',
    dot: 'var(--info)',
  },
};

const hexToRgba = (hex: string, alpha: number): string => {
  const m = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex.trim());
  if (!m) return `rgba(0,0,0,${alpha})`;
  return `rgba(${parseInt(m[1], 16)},${parseInt(m[2], 16)},${parseInt(m[3], 16)},${alpha})`;
};

export const StyledTag = styled.div<TagProps>`
  display: inline-flex;
  align-items: center;
  gap: 0.375rem;
  padding: 0.1875rem 0.5rem;
  border-radius: var(--r-full);
  font-size: 0.75rem;
  font-weight: 500;
  letter-spacing: -0.005em;
  line-height: 1.25;
  white-space: nowrap;

  ${({ status = TagStatus.Success, color }) => {
    if (color) {
      return css`
        background-color: ${hexToRgba(color, 0.14)};
        border: 1px solid ${hexToRgba(color, 0.32)};
        color: ${color};
      `;
    }
    const t = STATUS_TOKENS[status];
    return css`
      background-color: ${t.bg};
      border: 1px solid ${t.border};
      color: ${t.text};
    `;
  }}

  &::before {
    content: '';
    width: 0.4375rem;
    height: 0.4375rem;
    border-radius: 100%;
    flex-shrink: 0;
    background: ${({ status = TagStatus.Success, color }) =>
      color || STATUS_TOKENS[status].dot};
  }

  span {
    color: inherit;
  }
`;
